/**
 * Schéma & helpers du Voice Profile (5 questions).
 * Single source of truth pour le form, la validation, et le payload Supabase.
 */
import { z } from 'zod';

export const voiceProfileSchema = z.object({
  ton: z
    .string()
    .trim()
    .min(20, 'Décris ton ton en au moins 20 caractères (ex : direct mais bienveillant, sans jargon).'),
  exemples_posts: z
    .string()
    .trim()
    .min(50, 'Colle au moins un exemple de post qui a bien marché (≥50 caractères).'),
  sujets_tabous: z
    .string()
    .trim()
    .min(5, 'Liste au moins un sujet à éviter (politique, religion, concurrents…).'),
  signature: z
    .string()
    .trim()
    .min(5, 'Ta signature ou ton style de fin (ex : émojis, hashtags, phrase fétiche).'),
  references: z
    .string()
    .trim()
    .min(5, "Au moins une personne dont tu admires la voix (sans copier — c'est pour calibrer)."),
});

export type VoiceProfile = z.infer<typeof voiceProfileSchema>;

export const VOICE_PROFILE_QUESTIONS: Array<{
  field: keyof VoiceProfile;
  label: string;
  placeholder: string;
  hint: string;
}> = [
  {
    field: 'ton',
    label: '1. Ton — comment tu parles à ton audience ?',
    placeholder: 'Ex : direct, sans jargon, un peu d\'humour, jamais condescendant…',
    hint: 'Décris en 2-3 phrases.',
  },
  {
    field: 'exemples_posts',
    label: '2. Exemples — colle 1 ou 2 posts qui ont bien marché récemment',
    placeholder:
      'Tu peux coller le contenu complet, ou des extraits. Plus tu donnes, mieux les agents calibrent.',
    hint: 'Sert de référence pour le style.',
  },
  {
    field: 'sujets_tabous',
    label: '3. Sujets tabous — qu\'est-ce qu\'on n\'aborde JAMAIS ?',
    placeholder: 'Ex : politique, religion, concurrents nommés, vie privée famille…',
    hint: 'Liste ce qui ferait fuir ton audience.',
  },
  {
    field: 'signature',
    label: '4. Signature — ton style de fin de post',
    placeholder: 'Ex : 3 hashtags max, jamais d\'émojis, phrase d\'appel à l\'action standard…',
    hint: 'Émojis ? Hashtags ? Question finale ?',
  },
  {
    field: 'references',
    label: '5. Références — qui admire tu pour leur communication ?',
    placeholder: 'Ex : Justin Welsh, Léa Bey, ma propre dernière version…',
    hint: 'Pour calibrer, pas pour copier.',
  },
];

export const EMPTY_VOICE_PROFILE: VoiceProfile = {
  ton: '',
  exemples_posts: '',
  sujets_tabous: '',
  signature: '',
  references: '',
};
